import styled from 'styled-components';

export const StyledOperationToolInfoPresentation = styled.div`
  padding: 4% 6% 6% 6%;
`;
